import {
  Box,
  Grid,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    freeMonthCardText: {
      fontSize: 17,
      fontWeight: 400,
      color: '#0D2E68',
    },
    cardImage: {
      marginRight: 9,
      marginBottom: 0,
    },
  }),
);

const FreeMonthCard = (): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid item container>
      <Box pt={2}>
        <img
          src="/svg/credit_card.svg"
          alt="free_month"
          className={classes.cardImage}
        />
      </Box>
      <Box m={0} p={0} pt={2}>
        <Typography className={classes.freeMonthCardText}>
          Primer mes gratis
        </Typography>
      </Box>
    </Grid>
  );
};

export default FreeMonthCard;
